module.exports = __webpack_public_path__ + "static/var3-31af8e0a955f0deae328e6b18b12ccb4.jpg";